module.exports = __webpack_public_path__ + "img/PHOTO.517643ce.png";